module.exports = __webpack_public_path__ + "static/media/pilot.b7397bd8.png";